import styled from "styled-components";

export const ColumnTitleWrapper = styled.div`
    margin-top: 30px;
    margin-bottom: 15px;
    @media screen and (max-width: 750px) {
        margin-top: 15px;
        img {
            width: 50%;
        }
    }
`;
